<template>
    <div class="content-block">
        <div class="info-title">印章列表</div>
        <div class="seal-layer">
            <div v-for="(sealGroupItem, key) in sealInfoArrayMap" :key="key">
                <div class="sub-title">
                    <svg-icon iconClass="bar" width="2" height="12" style="margin-right: 8px;"></svg-icon>
                    <span v-if="key == 'companyCommon'">企业章</span>
                    <span v-if="key == 'person'">我的签名</span>
                    <span v-if="key == 'companyLegal'">法定代表人章</span>
                    <span v-if="key == 'companyAgent'">经办人签名</span>
                    <el-tooltip effect="dark" placement="right" v-if="key == 'person'">
                        <div slot="content" style="width: 390px;text-align: left;">
                            使用场景：1、签署个人合同时在合同中加盖您的个人签名 2、签署企业合同时作为经办人加盖您的个人签名
                        </div>
                        <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                  style="margin-left: 8px;margin-top: 1px;"></svg-icon>
                    </el-tooltip>
                    <el-tooltip effect="dark" placement="right" v-if="key == 'companyCommon'">
                        <div slot="content" style="width: 390px;text-align: left;">
                            使用场景：您作为企业签署企业合同时可使用”已授权“或”需审批“的企业章签署合同
                        </div>
                        <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                  style="margin-left: 8px;margin-top: 1px;"></svg-icon>
                    </el-tooltip>
                    <el-tooltip effect="dark" placement="right" v-if="key == 'companyLegal'">
                        <div slot="content" style="width: 390px;text-align: left;">
                            使用场景：您作为企业法定代表人签署企业合同时可使用”已授权“或”需审批“的企业章签署合同
                        </div>
                        <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                  style="margin-left: 8px;margin-top: 1px;"></svg-icon>
                    </el-tooltip>
                    <el-tooltip effect="dark" placement="right" v-if="key == 'companyAgent'">
                        <div slot="content" style="width: 390px;text-align: left;">
                            使用场景：您作为企业经办人签署企业合同时可使用”已授权“或”需审批“的企业章签署合同
                        </div>
                        <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                  style="margin-left: 8px;margin-top: 1px;"></svg-icon>
                    </el-tooltip>


                </div>
                <ul class="sign-list clearfix" :data-seal-type="key">
                    <li v-for="(item, itemIdx) in sealGroupItem" :key="itemIdx">
                        <div class="sign-box">
                            <el-image :src="item.sealImg" fit="contain" ref="preview" class="sign-img"
                                      :preview-src-list="sealGroupItem.map((item) => {
                return item.sealImg;
              })
                ">
                            </el-image>
                        </div>
                        <!-- <p class="sign-tip">
                                <span v-show="signatures.isGenerate == '1'">{{signatures.isGenerate == '1' ? '系统自动生成的印章' : ' '}}</span>
                                <span v-show="signatures.status==0" class="spz">{{ signatures.status==0?'用章审核中，请等待':'' }}</span>
                            </p> -->
                        <div class="sign-name">
                            <span class="sign-name-title">{{ item.sealName }}</span>


                            <div v-if="key == 'person'" style="height: 24px;">
                                <el-dropdown placement="top" style="margin: 0;" @command="handleSealItemCommand">
                                    <div class="flex-center dot-more">
                                        <svg-icon iconClass="dot-more" width="20" height="20"></svg-icon>
                                    </div>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="{ key: 'zoom', target: item, idx: itemIdx }">
                                            <svg-icon icon-class="tool-zoom" width="16" height="16"
                                                      style="margin-right: 8px;"></svg-icon>
                                            查看
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="{ key: 'rename', target: item, idx: itemIdx }">
                                            <svg-icon
                                                    icon-class="tool-edit" width="16" height="16"
                                                    style="margin-right: 8px;"></svg-icon>
                                            重命名
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="{ key: 'delete', target: item, idx: itemIdx }">
                                            <svg-icon
                                                    icon-class="tool-delete" width="16" height="16"
                                                    style="margin-right: 8px;"></svg-icon>
                                            删除
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>

                            <div class="flex-center" v-else>
                                <div class="seal-tag">
                                    <span class="tag process" v-if="item.status == 'processing'">需审核</span>
                                    <span class="tag authed" v-if="item.status == 'enable'">已授权</span>
                                    <span class="tag forbid" v-if="item.status == 'disable'">不可用</span>
                                </div>
                                <el-tooltip effect="dark" placement="top" v-if="item.status == 'enable'">
                                    <div slot="content" style="width: 220px;text-align: left;">
                                        您作为企业经办人签署企业合同时，可直接使用此印章进行签署
                                    </div>
                                    <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                              style="margin-left: 4px;margin-top: 1px;"></svg-icon>
                                </el-tooltip>
                                <el-tooltip effect="dark" placement="top" v-if="item.status == 'processing'">
                                    <div slot="content" style="width: 220px;text-align: left;">
                                        您作为企业经办人签署企业合同时，使用此印章签署需要发起用章审批流程，当用章审批流程中所有审批节点人员都审批通过后将自动加盖此印章到合同
                                    </div>
                                    <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                              style="margin-left: 4px;margin-top: 1px;"></svg-icon>
                                </el-tooltip>
                                <el-tooltip effect="dark" placement="top" v-if="item.status == 'disable'">
                                    <div slot="content" style="width: 220px;text-align: left;">
                                        不可用原因为管理员没有给您授权直接使用此印章的权限，同时管理员也没有开启企业内部用章流程的设置，导致您无法使用此章
                                    </div>
                                    <svg-icon iconClass="icon-info-grey" width="16" height="16"
                                              style="margin-left: 4px;margin-top: 1px;"></svg-icon>
                                </el-tooltip>
                            </div>

                        </div>
                    </li>
                    <li class="new-sign" v-if="key == 'person'" @click="handleCreateSeal">
                        <div class="dash-rect">
                            <svg-icon icon-class="icon-plus" width="23" height="23"></svg-icon>
                        </div>
                        <div class="title">
                            新增签名
                        </div>
                    </li>
                </ul>
                <div class="blank-help" v-if="key == 'companyCommon' && !sealGroupItem.length">
                    <div class="help-content">
                        <div class="title flex-center">
                            <svg-icon icon-class="icon-info-dark" width="20" height="20"
                                      style="margin-right: 8px"></svg-icon>
                            暂无印章
                        </div>
                        <div class="content">
                            <div class="ques-title">为什么没有可用的企业章？</div>
                            <div>
                                <div>
                                    1、企业管理员没有制作企业章
                                </div>
                                <div>
                                    2、企业管理员没有启用企业章的可用状态
                                </div>
                                <div>
                                    3、您可以联系企业管理员制作或启用企业章，并给您授权印章的使用权限
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blank-help" v-if="key == 'companyLegal' && !sealGroupItem.length">
                    <div class="help-content">
                        <div class="title flex-center">
                            <svg-icon icon-class="icon-info-dark" width="20" height="20"
                                      style="margin-right: 8px"></svg-icon>
                            暂无印章
                        </div>
                        <div class="content">
                            <div class="ques-title">为什么没有可用的法定代表人章？</div>
                            <div>
                                <div>
                                    1、企业管理员没有制作法定代表人章
                                </div>
                                <div>
                                    2、企业管理员没有启用法定代表人章的可用状态
                                </div>
                                <div>
                                    3、您可以联系企业管理员制作或启用法定代表人章，并给您授权印章的使用权限
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <draw-sign ref="draw"></draw-sign>
        <reset-sealname ref="reset" :sealId="sealId"></reset-sealname>
        <el-dialog title="" :visible.sync="renameDialog" custom-class="rename-dialog" width="480px"
                   :close-on-click-modal="false" :show-close="false" append-to-body>
            <div class="title">重命名签章名称</div>
            <el-form @submit.native.prevent :model="sealForm" label-width="0" :rules="sealRules" ref="sealForm"
                     class="seal-Form">
                <el-form-item prop="sealName">
                    <el-input size="small" v-model="sealForm.sealName" maxlength="10" show-word-limit placeholder="请输入签章名称"
                              clearable></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button size="small" class="grey-btn" @click="handleCancelRename">取消
        </el-button>
        <el-button type="primary" size="small" :disabled="!sealForm.sealName"
                   @click="handleConfirmRename">确定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
    import drawSign from "./draw-sign";
    import resetSealname from "./reset-sealname";
    import {
        getUserSealInfoApi,
        deleteSealApi,
        setDefaultSealApi,
    } from "@/api/space/signatures";
    import {getSpaceDetailInfo} from "@/api/home";
    import {getSealList, pcSealUpdate, pcIndexDeleteSeal} from "@/api/common";
    import {getToken} from "@/utils/auth";

    export default {
        data() {
            return {
                sealInfoArrayMap: {},
                sealId: "",
                clickDefault: false,
                userScope: {},
                renameDialog: false,
                sealForm: {
                    sealName: ""
                },
                sealRules: {
                    sealName: [{
                        required: true,
                        message: '请输入签章名称',
                        trigger: 'blur'
                    }],
                },
                cmd: {}
            };
        },
        created() {
            this.handleGetSpaceDetailInfo();
        },
        mounted() {
            this.getUserSealInfoHandle();
        },
        components: {
            drawSign,
            resetSealname,
        },
        methods: {
            init() {
                this.getUserSealInfoHandle();
            },
            handleCancelRename() {
                this.renameDialog = false;
                this.$refs.sealForm.resetFields();
            },
            handleConfirmRename() {
                pcSealUpdate({
                    sealId: this.cmd.target.sealId,
                    sealName: this.sealForm.sealName
                }).then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: "修改成功！",
                            type: "success",
                        });
                        this.getUserSealInfoHandle();
                    }
                })
                this.renameDialog = false;
                this.$refs.sealForm.resetFields();

            },
            handleGetSpaceDetailInfo() {
                getSpaceDetailInfo().then((res) => {
                    if (res.code === 200) {
                        this.userScope = res.data;
                    }
                });
            },
            getUserSealInfoHandle() {
                getSealList({
                    pageNum: 1,
                    pageSize: 100,
                })
                    .then((res) => {
                        if (res.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {

                            // 印章排序
                            const sequence = ["person", "companyCommon", "companyLegal", "companyAgent"];
                            res.data.sealInfoArray.sort((prev, next) => {
                                return sequence.indexOf(prev.sealType) - sequence.indexOf(next.sealType)
                            })
                            // 印章分组
                            const groups = res.data.sealInfoArray.reduce((groups, item) => {
                                const key = item.sealType;
                                if (!groups[key]) {
                                    groups[key] = [];
                                }
                                groups[key].push(item);
                                return groups;
                            }, {});
                            if (!groups["companyCommon"]) {
                                // groups["companyCommon"] = []
                            }
                            if (!groups["companyLegal"]) {
                                // groups["companyLegal"] = []
                            }
                            if (!groups["person"]) {
                                groups["person"] = []
                            }
                            this.sealInfoArrayMap = groups;

                            // this.sealList = res.data.sealInfoArray.filter(_item => {
                            //   return _item.status == "enable";
                            // });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            handleSealItemCommand(cmd) {
                this.cmd = cmd;
                switch (cmd.key) {
                    case 'zoom':
                        this.$refs.preview[cmd.idx].clickHandler()
                        break;
                    case 'rename':
                        this.renameDialog = true
                        break;
                    case 'delete':
                        this.$confirm("签名删除后将无法找回，确定要删除该签名吗？", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                            center: true,
                            showClose: false
                        }).then(() => {
                            pcIndexDeleteSeal({
                                sealId: this.cmd.target.sealId
                            }).then((res) => {
                                if (res.code !== 200) {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "warning",
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.getUserSealInfoHandle();
                                }
                            })
                        }).catch(() => {
                        });

                        break;
                    default:
                        ;
                }
            },
            toMakeSeal() {
                location.href = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL) + "sealManager/seal";
            },
            // 个人新增签名
            handleCreateSeal() {
                this.$router.push('/create-sign')
            },
            deleteSealHandle(sealId) {
                this.$confirm("确定要删除吗？", "温馨提示", {
                    confirmButtonText: "删除",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true,
                    showClose: false
                })
                    .then(() => {
                        deleteSealApi({
                            sealId,
                        })
                            .then((res) => {
                                if (res.code !== 200) {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "warning",
                                    });
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: "删除成功！",
                                        type: "success",
                                    });

                                    this.$nextTick(() => {
                                        this.init();
                                    });
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    })
                    .catch(() => {
                    });
            },
            setDefaultHandle(sealId) {
                if (!this.clickDefault) {
                    this.clickDefault = true;
                    setDefaultSealApi({
                        sealId,
                    })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                                this.clickDefault = false;
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "设置成功！",
                                    type: "success",
                                });

                                this.$nextTick(() => {
                                    this.init();
                                    this.clickDefault = false;
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            },
            showResetDialogHandle(id, sealName) {
                this.sealId = id;
                this.$refs.reset.sealForm.sealName = sealName;
                this.$refs.reset.dialogVisible = true;
            },
            showDraw() {
                this.$refs.draw.dialogVisible = true;
                this.$refs.draw.getDrawCodeHandle();
            },
        },
    };
</script>
<style scoped>
    .sign-title {
        border-left: 2px solid #3296fa;
        height: 21px;
        line-height: 21px;
        color: #333333;
        font-size: 16px;
        text-indent: 10px;
        margin: 18px 0 0 22px;
    }

    /* .sign-list li {
      width: 152px;
      float: left;
      margin-right: 24px;
      height: 230px;
    }

    .sign-list li:nth-of-type(5n) {
      margin-right: 0;
    } */


    .sign-delete {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 152px;
        height: 31px;
        background: rgba(191, 191, 191, 1);
        border-radius: 0px 0px 10px 10px;
        text-align: center;
        line-height: 31px;
        font-size: 14px;
        color: #ffffff;
        display: none;
    }

    .new-icon,
    .new-icon2 {
        position: absolute;
        right: 0;
        top: 0;
        display: none;
    }

    .sign-tip {
        width: 152px;
        text-align: center;
        font-size: 14px;
        color: #999999;
        margin-top: 4px;
        height: 16px;
    }

    .sign-btns {
        width: 152px;
        /* display: flex;
                                                              justify-content: space-between; */
        margin-top: 10px;
        position: relative;
    }

    .sign-btns a {
        display: block;
        float: right;
        width: 72px;
        height: 38px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        line-height: 38px;
        background: #242b39;
        border-radius: 4px;
    }

    .sign-btns .set-default {
        width: 72px;
        height: 38px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        line-height: 38px;
        background: #e85052;
        border-radius: 4px;
        float: left;
    }

    /* .set-default:hover{
                                                            background: #ed7375;
                                                          } */

    .set-auth {
        background: #242b39;
        width: 54px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        color: #ffffff;
        border-radius: 4px;
        font-size: 14px;
    }

    /* .sign-name {
      width: 152px;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      font-size: 16px;
    }

    .sign-name-title {
      color: #333333;
      line-height: 17px;
      text-align: center;
      width: 100%;
    }

    .sign-name-text {
      width: 70px;
      text-align: right;
      height: 16px;
      line-height: 16px;
      overflow: hidden;
      color: #3296fa;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    } */

    .mask-tip {
        font-size: 14px;
        color: #3296fa;
        margin: 16px 0 0 22px;
    }

    .add-sign {
        width: 100px;
        margin-left: 35px;
        margin-top: 38px;
    }

    .edit-name {
        float: right !important;
    }

    .sign-box:hover .sign-delete {
        display: block;
    }

    .sign-box:hover .new-icon {
        display: block;
    }

    /* .default-sign{
                                                            display: block;
                                                            width:78px;
                                                            height:38px;
                                                            background:rgba(180,56,58,1);
                                                            box-shadow:0px 2px 12px 1px rgba(0, 0, 0, 0.08);
                                                            border-radius:4px;
                                                            position: absolute;
                                                            left: 0;
                                                            top: 0;
                                                            text-align: center;
                                                            line-height: 38px;
                                                            color: #FFFFFF;
                                                            font-size: 14px;
                                                          } */

    .new-icon2 {
        display: block;
    }
</style>
<style lang="scss" scoped>
    .content-block {
        position: relative;
        height: 100%;
    }

    .info-title {
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        font-weight: 500;
        color: #1D2129;
        border-bottom: 1px solid #F2F3F5;
        padding-left: 22px;
    }

    .seal-layer {
        padding: 30px 0 30px 40px;
        height: calc(100% - 60px);
        overflow: auto;

        .sub-title {
            font-size: 15px;
            font-weight: 500;
            color: #313843;
            display: flex;
            align-items: center;
            margin-bottom: 30px;
        }

        .blank-help {
            width: 100%;
            padding-right: 40px;
            margin-bottom: 30px;

            .help-content {
                width: 100%;
                height: 100%;
                background: #F7F8FA;
                border-radius: 16px;
                padding: 16px 30px 20px;

                .title {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                    padding-bottom: 16px;
                    border-bottom: 1px solid #E7E9EE;
                }

                .content {
                    font-size: 13px;
                    font-weight: 400;
                    color: #86909C;
                    line-height: 22px;
                }

                .ques-title {
                    font-size: 14px;
                    font-weight: 500;
                    color: #4E5969;
                    line-height: 22px;
                    padding-top: 16px;
                    padding-bottom: 10px;
                }
            }
        }

        .sign-list {

            &[data-seal-type="person"],
            &[data-seal-type="companyLegal"],
            &[data-seal-type="companyAgent"] {
                .sign-img {
                    width: 140px;
                    height: 70px;
                }

            }

            li {
                width: 200px;
                display: inline-block;
                margin-right: 48px;
                border: 1px solid #E7E9EE;
                border-radius: 16px;
                margin-bottom: 40px;
                vertical-align: middle;

                .sign-box {
                    width: 140px;
                    height: 140px;
                    position: relative;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 20px auto;
                }

                .sign-img {
                    display: block;
                    width: 140px;
                    height: auto;
                }

                .sign-name {
                    border-top: 1px solid #E7E9EE;
                    padding: 16px;
                    height: 52px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #313843;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .dot-more {
                        width: 24px;
                        height: 24px;
                        border-radius: 4px 4px 4px 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;

                        &:hover {
                            background: #F3F3F7;
                        }
                    }

                    .sign-name-title {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-right: 10px;
                    }

                    .tag {
                        display: inline-block;
                        width: 48px;
                        height: 20px;
                        line-height: 18px;
                        background: #F5FBF5;
                        border-radius: 4px 4px 4px 4px;
                        text-align: center;
                        border: 1px solid #B9E2C6;
                        font-size: 12px;
                        font-weight: 400;

                        &.authed {
                            background: #F5FBF5;
                            border: 1px solid #B9E2C6;
                            color: #38A65A;
                        }

                        &.process {
                            background: #FFF8F9;
                            border: 1px solid #FFCACD;
                            color: #EB6069;
                        }

                        &.forbid {
                            background: #F2F3F5;
                            border: 1px solid #C4CEDB;
                            color: #86909C;
                        }
                    }
                }
            }

            .new-sign {
                width: 200px;
                height: 232px;
                background: linear-gradient(180deg, #F0F5FF 0%, #FFFFFF 100%);
                border: 1px solid #E4ECFF;
                text-align: center;
                cursor: pointer;

                .dash-rect {
                    width: 98px;
                    height: 99px;
                    background: rgba(255, 255, 255, 0);
                    border-radius: 16px 16px 16px 16px;
                    border: 1.5px dashed #3F7BF9;
                    margin: 47px auto 0;
                }

                .title {
                    font-size: 14px;
                    font-weight: 500;
                    color: #3F7BF9;
                    margin-top: 20px;
                }
            }
        }


    }


    .content-layer {
        padding: 20px;
    }
</style>
<style lang="scss">
    .rename-dialog {

        border-radius: 9px;
        width: 480px;
        height: 200px;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: auto !important;


        .el-dialog__header {
            padding: 0;
        }

        .el-dialog__body {
            padding: 32px 32px 0;
        }

        .seal-Form {
            padding: 25px 0;

            .el-form-item {
                margin: 0;
            }
        }

        .title {
            font-size: 16px;
            font-weight: 600;
            color: #313843;
        }

        .el-dialog__footer {
            padding: 0 32px 32px;
        }
    }
</style>
